const state: any = {
  all: [],
};

export default state;
